// ABOUTME: The Suspense boundary a lazy page mounts in: the card skeleton fills the page area
// ABOUTME: while the chunk loads, one boundary per route so the frame around it stays put.

import type { FC, PropsWithChildren } from "react"
import { Suspense } from "react"
import { CPageLoading } from "@shared/ui"

export const LazyPage: FC<PropsWithChildren> = ({ children }) => (
  <Suspense fallback={<CPageLoading />}>{children}</Suspense>
)
